import React from 'react'

/**
 * VacancyCardSkeleton
 * Mirrors the structure of the VacancyCard in HeroSearch.jsx
 * Uses animate-pulse to provide a smooth loading experience
 */
const VacancyCardSkeleton = () => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col h-full">
      {/* Top Accent Bar */}
      <div className="h-1.5 bg-indigo-100 w-full" />

      {/* Card Body */}
      <div className="p-6 flex flex-col flex-grow">
        {/* Header: Badges & Title */}
        <div className="mb-5">
          <div className="flex flex-wrap gap-2 mb-3">
            <div className="animate-pulse bg-gray-200 h-5 w-20 rounded-full" />
            <div className="animate-pulse bg-gray-200 h-5 w-24 rounded-full" />
          </div>

          {/* Title - 2 lines skeleton */}
          <div className="space-y-2 mb-4">
            <div className="animate-pulse bg-gray-200 h-6 w-full rounded-md" />
            <div className="animate-pulse bg-gray-200 h-6 w-3/4 rounded-md" />
          </div>
          
          {/* Company info */}
          <div className="flex items-center">
            <div className="w-6 h-6 rounded-md bg-gray-100 flex-shrink-0 mr-2" />
            <div className="animate-pulse bg-gray-200 h-4 w-32 rounded-md" />
          </div>
        </div>

        {/* Info Grid - 2x2 */}
        <div className="grid grid-cols-2 gap-y-4 gap-x-2 mb-6 flex-grow">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="flex items-start">
              <div className="w-8 h-8 rounded-lg bg-gray-100 mr-3 flex-shrink-0" />
              <div className="min-w-0 space-y-1.5">
                <div className="animate-pulse bg-gray-100 h-2 w-10 rounded-md" />
                <div className="animate-pulse bg-gray-200 h-3 w-16 rounded-md" />
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="pt-5 border-t border-gray-50 mt-auto">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-1.5">
              <div className="w-3.5 h-3.5 rounded-full bg-gray-100" />
              <div className="animate-pulse bg-gray-200 h-3 w-20 rounded-md" />
            </div>
            <div className="animate-pulse bg-gray-200 h-3 w-16 rounded-md" />
          </div>

          {/* Search CTA Bar Skeleton */}
          <div className="w-full h-11 bg-gray-50 rounded-xl border border-gray-100 flex items-center justify-center px-4">
            <div className="animate-pulse bg-gray-200 h-4 w-2/3 rounded-md" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default VacancyCardSkeleton
